import { WorkflowStepCardData } from 'constants/WorkingModePathwaysConstants'

import { renderSegments } from './renderSegments'

interface WorkflowStepCardProps {
  step: WorkflowStepCardData
}

export const WorkflowStepCard = ({ step }: WorkflowStepCardProps) => (
  <div className="insights-output-card pathway-workflow-step-card">
    <p className="body-xs w-[190px]">{renderSegments(step.segments)}</p>
    <span className={step.number === 1 ? 'insights-output-card-number-one' : 'insights-output-card-number'}>
      {step.number}
    </span>
  </div>
)
